<template>
  <!-- flex bags -->
  <content-section
    :icon="svg_luggage()"
    title="Bagagli in stiva extra"
    :description="
      Object.keys(bags).length > 0
        ? `Scegli i bagagli al checkin per passeggero e per itinierario.`
        : `Non è possibile aggiungere bagagli extra su questo volo. Normalmente
            è possibile farlo sul sito della compagnia aerea dopo avere
            effettuato la prenotazione. E' anche possibile che in questa pagina,
            nella sezione Tariffe, ti vengano proposte delle Tariffe che
            includono bagagli a mano o in stiva. Controlla.`
    "
    :classes="'bags'"
  >
    <template v-if="Object.keys(bags).length > 0">
      <div class="overflow-auto">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th>Andata</th>
              <th>Ritorno</th>
            </tr>
          </thead>
          <tbody
            v-for="(traveler, traveler_index) in flexible_bags"
            v-bind:key="traveler_index + _uid"
          >
            <tr>
              <td class="py-2 px-1 bags--traveler" rowspan="999999">
                <!-- inutile creare un metodo solo per calcolare questo valore -->
                <b>Viaggiatore {{ traveler_details[traveler_index].id }}</b>
                ({{ transcode_traveler_type(traveler_details[traveler_index].traveler_type) }})
              </td>
            </tr>
            <tr v-for="(bag, bag_index) in bags" v-bind:key="traveler_index + bag_index + _uid">
              <template v-if="bag.quantity < 3">
                <td class="py-2 px-0">
                  <div>
                    <strong>
                      {{ bag.quantity ? bag.quantity : '1' }}
                      {{ bag.quantity > 1 ? 'bagagli' : 'bagaglio' }}
                    </strong>
                    <span v-if="bag.weight"> ({{ bag.weight }} {{ bag.weightUnit }} totali)</span>
                    +{{ bag_price(bag) }} {{ bag.price.currencyCode }}/itinerario
                  </div>

                  <div
                    class="badge-baggage mt-2"
                    v-b-popover.hover.top="
                      bag.bookableByItinerary ? badge_popover_unlock : badge_popover_lock
                    "
                  >
                    <b-badge variant="light" class="py-1">
                      <span
                        v-if="bag.bookableByItinerary"
                        v-html="unlock"
                        class="badge--icon"
                      ></span>
                      <span v-else v-html="lock" class="badge--icon"></span>
                      <span class="badge--text">{{
                        bag.bookableByItinerary ? 'Sui singoli itinerari' : 'Su tutti gli itinerari'
                      }}</span>
                    </b-badge>
                  </div>
                </td>
                <td
                  class="py-2 px-0 text-center"
                  v-for="(itinerary, itinerary_index) in flight_offer.itineraries"
                  v-bind:key="itinerary_index"
                  :set="
                    available =
                      itinerary.segments.filter((s) => {
                        return bag.segmentIds.includes(s.id);
                      }).length > 0
                  "
                >
                  <!--<b-badge v-if="!available" variant="gray">non disponibile</b-badge>-->
                  <b-form-checkbox
                    v-if="available"
                    :key="flexible_bags_update_key"
                    :checked="flexible_bags[traveler_index][itinerary_index][bag_index].added"
                    @change="
                      (value) => {
                        flexible_bags_updated(value, {
                          traveler_index: number(traveler_index),
                          itinerary_index: number(itinerary_index),
                          bag_index: number(bag_index),
                          bookableByItinerary: bag.bookableByItinerary,
                        });
                      }
                    "
                  ></b-form-checkbox>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
        <div class="text-right mr-md-5">
          <b-button
            variant="tertiary"
            size="medium"
            :disabled="flexible_bags_update_key == 0"
            @click="handle_add_flexible_bag_to_flight_offer(flight_offer, flexible_bags)"
          >
            Aggiorna
          </b-button>
        </div>
      </div>
    </template>
  </content-section>
</template>

<script>
import { divide, number } from 'mathjs';
import { transcode_traveler_type, apply_markup_to_number } from '@/flight-offer';
import { lock, unlock } from '@/components/svg/flight';
import { luggage } from '@/components/svg/bags';
import ContentSection from '@/components/blocks/wrappers/content-section';

export default {
  name: 'additional-bags-table',
  props: {
    traveler_details: Array,

    flexible_bags: Object,
    bags: Object,

    flexible_bags_update_key: Number,
    flight_offer: Object,

    handle_add_flexible_bag_to_flight_offer: Function,
    flexible_bags_updated: Function,
  },
  components: {
    'content-section': ContentSection,
  },
  data() {
    return {
      lock,
      unlock,
      svg_luggage: luggage,
      badge_popover_lock:
        'Il bagaglio extra non è acquistabile per un singolo itinerario ma solo per tutto il viaggio.',
      badge_popover_unlock:
        'Puoi acquistare il bagaglio extra anche per una sola parte del viaggio.',
    };
  },
  methods: {
    number,
    divide,
    apply_markup_to_number,
    transcode_traveler_type,
    bag_price(bag) {
      const bag_live_price = this.apply_markup_to_number(this.flight_offer, bag.price.amount);
      const itineraries_count = (this.flight_offer.itineraries || []).length;
      if (bag.bookableByItinerary || itineraries_count !== 0) {
        return bag_live_price;
      }
      return this.divide(bag_live_price, itineraries_count);
    },
  },
};
</script>

<style lang="scss" scoped>
.bags {
  overflow: hidden;
  .table {
    thead {
      background-color: #f8f9fa;

      th {
        border-bottom: 0;
        text-align: center;
      }
    }
    tbody {
      border-bottom: 1px solid $gray-300;

      &:before {
        content: '';
        display: block;
        height: 10px;
      }

      & + tbody {
        border: 0;
      }
    }

    td {
      border-width: 0 0 1px;
      border-style: solid;
      border-color: $gray-300;
    }
  }
  &--traveler {
    max-width: 100px;
  }
}
</style>
